export default __webpack_public_path__ + "assets/mixes.png";